import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/globals.css");
